export const checkIfAdmin = (userRole: string): boolean => userRole === 'admin' || userRole === 'sub_admin'
